// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-black[data-v-667935a8]{color:#000 !important}.text-white[data-v-667935a8]{color:#fff !important}", ""]);
// Exports
module.exports = exports;
